import React, { memo } from 'react';
const Loader = memo(({ classNameChange = false }) => {
    return (
        <div className={classNameChange ? 'plan-wrapper' : 'wrapper'}>
            <div className="loader"></div>
        </div>
    );
});
export default Loader;
